import { render, staticRenderFns } from "./NewShortcut.vue?vue&type=template&id=61aaa003&scoped=true"
import script from "./NewShortcut.vue?vue&type=script&lang=js"
export * from "./NewShortcut.vue?vue&type=script&lang=js"
import style0 from "./NewShortcut.vue?vue&type=style&index=0&id=61aaa003&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aaa003",
  null
  
)

export default component.exports